import React, { Component } from "react";
import {
  PageHeader, Row, Col, Card, Spin, Empty, message,
  Table, Select, Space, Tooltip, Tabs,
} from "antd";
import { PieChartOutlined, FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import {
  Form, FormItem, ButtonItem, SelectItem, RangePickerItem,
} from "../../../../Components/Items";
import { HeaderEmpresaCard } from "../../../../Components/PdfComponents/HeaderEmpresaCard";
import { ResponsivePie } from "@nivo/pie";
import axios from "axios";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

const COLORES_ORIGEN  = ["#4e79a7","#f28e2b","#e15759","#76b7b2","#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ac"];
const COLORES_PERDIDA = ["#ff4d4f","#ff7875","#ffa39e","#ffccc7","#ffd666","#ffc53d","#ffec3d","#bae637"];

const CARD_STYLE = { borderRadius: 10, overflow: "hidden" };

const COLORES_PDF = [
  "#4e79a7","#f28e2b","#e15759","#76b7b2",
  "#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ac",
];

const PDF_STYLES = {
  header:               { fontSize: 9, bold: true },
  subheader:            { fontSize: 8, bold: true },
  tableExample:         { margin: [0, 5, 0, 5] },
  tableHeader:          { bold: true, fontSize: 12, color: "black", alignment: "center" },
  tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
  textoChico:           { fontSize: 8 },
  tituloTabla:          { fontSize: 7, bold: true, fillColor: "#cccccc", alignment: "center" },
  textoTabla:           { fontSize: 7 },
  totalChico:           { fontSize: 7, bold: true, fillColor: "#cccccc", alignment: "right" },
};

const buildBarras = (datos, getVal, getLabel, total = 0) => {
  const maxV = Math.max(...datos.map(getVal), 1);
  const W = 150, H = 11, G = 5;
  return {
    columns: [
      {
        width: W,
        canvas: datos.map((d, i) => ({
          type: "rect", x: 0, y: i * (H + G),
          w: Math.max(2, Math.round((getVal(d) / maxV) * W)),
          h: H, color: COLORES_PDF[i % COLORES_PDF.length], r: 2,
        })),
      },
      {
        width: "*",
        margin: [8, 0, 0, 0],
        stack: datos.map((d) => ({
          text: `${getLabel(d)}  ${getVal(d)}${total > 0 ? ` (${((getVal(d) / total) * 100).toFixed(1)}%)` : ""}`,
          style: "textoTabla", color: "#444", margin: [0, 2, 0, G - 2],
        })),
      },
    ],
    margin: [0, 4, 0, 8],
  };
};

class ReporteLeadsCRM extends Component {
  formRef = React.createRef();

  state = {
    loadingOrigen:  false,
    loadingMotivos: false,
    datosOrigen:    [],
    datosMotivos:   [],
    embudos:        [],
    periodoStr:     "",
  };

  componentDidMount() {
    this.cargarEmbudos();
  }

  cargarEmbudos = async () => {
    const defaultValues = { periodo: [moment().startOf("year"), moment()] };
    try {
      const res = await axios.post(
        "embudos/selectEmbudosItem",
        { empresaId: this.props.empresaId, query: "" },
        { headers: this.props.headersToken },
      );
      if (res.data.success === 2) {
        this.setState({ embudos: res.data.embudos ?? [] }, () => {
          this.onFinish(defaultValues);
        });
      } else {
        this.onFinish(defaultValues);
      }
    } catch {
      this.onFinish(defaultValues);
    }
  };

  onFinish = (values) => {
    const { periodo, embudoId } = values;
    const periodoStr = periodo
      ? `${periodo[0].format("DD/MM/YYYY")} - ${periodo[1].format("DD/MM/YYYY")}`
      : "Histórico completo";
    this.setState({ periodoStr });
    this.cargarDatos({
      fechaInicio: periodo?.[0]?.toISOString() ?? null,
      fechaFin:    periodo?.[1]?.toISOString() ?? null,
      embudoId:    embudoId ?? null,
    });
  };

  cargarDatos = async ({ fechaInicio, fechaFin, embudoId } = {}) => {
    this.setState({ loadingOrigen: true, loadingMotivos: true });
    try {
      const [resOrigen, resMotivos] = await Promise.all([
        axios.post(
          "reportesCRM/origenProspectos",
          { empresaId: this.props.empresaId, fechaInicio, fechaFin, embudoId },
          { headers: this.props.headersToken },
        ),
        axios.post(
          "reportesCRM/motivosPerdidaReporte",
          { empresaId: this.props.empresaId, fechaInicio, fechaFin, embudoId },
          { headers: this.props.headersToken },
        ),
      ]);
      if (resOrigen.data.success  === 2) this.setState({ datosOrigen:  resOrigen.data.datos });
      if (resMotivos.data.success === 2) this.setState({ datosMotivos: resMotivos.data.datos });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ loadingOrigen: false, loadingMotivos: false });
    }
  };

  descargarExcel = () => {
    const { datosOrigen, datosMotivos } = this.state;
    const wsOrigen  = XLSX.utils.json_to_sheet(datosOrigen.map((d)  => ({ Origen: d.id, Leads: d.value })));
    const wsMotivos = XLSX.utils.json_to_sheet(datosMotivos.map((d) => ({ "Motivo de Pérdida": d.id, Leads: d.value })));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsOrigen,  "Origen de Prospectos");
    XLSX.utils.book_append_sheet(wb, wsMotivos, "Motivos de Pérdida");
    XLSX.writeFile(wb, `Origen_Perdidas_CRM_${new Date().toLocaleDateString("es-MX").replace(/\//g, "-")}.xlsx`);
  };

  descargarPdf = async () => {
    this.setState({ loadingOrigen: true });
    try {
      const { datosOrigen, datosMotivos, periodoStr } = this.state;
      const totalOrigen  = datosOrigen.reduce((s, d)  => s + d.value, 0);
      const totalMotivos = datosMotivos.reduce((s, d) => s + d.value, 0);

      const resEmpresa = await axios.post(
        "reportesCRM/datosEmpresaPdf",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      );
      const empresa = resEmpresa.data.success === 2 ? resEmpresa.data.empresa : {};

      const graficaOrigen  = datosOrigen.length
        ? buildBarras(datosOrigen,  (d) => d.value, (d) => d.id, totalOrigen)
        : null;
      const graficaMotivos = datosMotivos.length
        ? buildBarras(datosMotivos, (d) => d.value, (d) => d.id, totalMotivos)
        : null;

      const terceraColumna = {
        border: [false, false, false, false],
        table: {
          widths: ["100%"],
          body: [
            [{ text: "Origen & Pérdidas CRM", style: "tableHeader", alignment: "center" }],
            [{ text: periodoStr,               style: "textoChico",  alignment: "center" }],
            [{ text: "Fecha de Impresión:",    style: "subheader",   alignment: "center" }],
            [{ text: new Date().toLocaleDateString("es-MX"), style: "textoChico", alignment: "center" }],
          ],
        },
        layout: "noBorders",
      };

      const docDef = {
        pageSize:    "LETTER",
        pageMargins: [20, 20, 20, 40],
        content: [
          {
            style: "tableExample",
            table: {
              widths: ["15%", "55%", "30%"],
              body: [[...HeaderEmpresaCard(empresa, false, false, terceraColumna)]],
            },
          },
          { text: "Origen & Pérdidas de Leads", style: "tableHeaderIzquierda", margin: [0, 6, 0, 8] },
          {
            columns: [
              {
                width: "50%",
                stack: [
                  { text: "Origen de Prospectos", style: "subheader", margin: [0, 0, 0, 4] },
                  ...(graficaOrigen ? [graficaOrigen] : [{ text: "Sin datos", style: "textoChico" }]),
                  ...(datosOrigen.length ? [{
                    style: "tableExample",
                    table: {
                      headerRows: 1,
                      widths: ["*", "auto", "auto"],
                      body: [
                        [
                          { text: "Origen",      style: "tituloTabla" },
                          { text: "Leads",       style: "tituloTabla" },
                          { text: "% del Total", style: "tituloTabla" },
                        ],
                        ...datosOrigen.map((d) => [
                          { text: d.id,    style: "textoTabla" },
                          { text: d.value, style: "textoTabla", alignment: "right" },
                          { text: totalOrigen > 0 ? `${((d.value / totalOrigen) * 100).toFixed(1)}%` : "—", style: "textoTabla", alignment: "right" },
                        ]),
                      ],
                    },
                    layout: {
                      fillColor:  (i) => i % 2 === 0 && i !== 0 ? "#e8e8e8" : "#ffffff",
                      hLineColor: () => "#adaaaa",
                      vLineColor: () => "#adaaaa",
                    },
                  }] : [{ text: "" }]),
                ],
              },
              { width: 12, text: "" },
              {
                width: "*",
                stack: [
                  { text: "Motivos de Pérdida", style: "subheader", margin: [0, 6, 0, 4] },
                  ...(graficaMotivos ? [graficaMotivos] : [{ text: "Sin datos", style: "textoChico" }]),
                  ...(datosMotivos.length ? [{
                    style: "tableExample",
                    table: {
                      headerRows: 1,
                      widths: ["*", "auto", "auto"],
                      body: [
                        [
                          { text: "Motivo",      style: "tituloTabla" },
                          { text: "Leads",       style: "tituloTabla" },
                          { text: "% del Total", style: "tituloTabla" },
                        ],
                        ...datosMotivos.map((d) => [
                          { text: d.id,    style: "textoTabla" },
                          { text: d.value, style: "textoTabla", alignment: "right" },
                          { text: totalMotivos > 0 ? `${((d.value / totalMotivos) * 100).toFixed(1)}%` : "—", style: "textoTabla", alignment: "right" },
                        ]),
                      ],
                    },
                    layout: {
                      fillColor:  (i) => i % 2 === 0 && i !== 0 ? "#e8e8e8" : "#ffffff",
                      hLineColor: () => "#adaaaa",
                      vLineColor: () => "#adaaaa",
                    },
                  }] : [{ text: "" }]),
                ],
              },
            ],
            margin: [0, 4, 0, 0],
          },
        ],
        images: { logo: empresa?.logo?.base64Completa ?? "" },
        styles: PDF_STYLES,
      };
      pdfMake.createPdf(docDef).download(`Origen_Perdidas_CRM_${new Date().toLocaleDateString("es-MX").replace(/\//g, "-")}.pdf`);
    } catch (e) {
      message.error("Hubo un error al generar el PDF.");
    } finally {
      this.setState({ loadingOrigen: false });
    }
  };

  render() {
    const { loadingOrigen, loadingMotivos, datosOrigen, datosMotivos, embudos } = this.state;
    const { history } = this.props;

    const loading      = loadingOrigen || loadingMotivos;
    const totalMotivos = datosMotivos.reduce((s, d) => s + d.value, 0);
    const totalOrigen  = datosOrigen.reduce((s, d)  => s + d.value, 0);
    const hayDatos     = datosOrigen.length > 0 || datosMotivos.length > 0;

    const columnsOrigen = [
      { title: "#",    render: (_, __, i) => i + 1, width: 36, align: "center" },
      { title: "Origen", dataIndex: "id" },
      { title: "Leads",  dataIndex: "value", align: "center" },
      { title: "% del Total", align: "right",
        render: (_, r) => totalOrigen > 0 ? `${((r.value / totalOrigen) * 100).toFixed(1)}%` : "—" },
    ];
    const columnsMotivos = [
      { title: "#",    render: (_, __, i) => i + 1, width: 36, align: "center" },
      { title: "Motivo de Pérdida", dataIndex: "id" },
      { title: "Leads", dataIndex: "value", align: "center" },
      { title: "% del Total", align: "right",
        render: (_, r) => totalMotivos > 0 ? `${((r.value / totalMotivos) * 100).toFixed(1)}%` : "—" },
    ];

    return (
      <Form
        ref={this.formRef}
        onFinish={this.onFinish}
        initialValues={{ periodo: [moment().startOf("year"), moment()] }}
      >
        <PageHeader
          title={<span><PieChartOutlined style={{ marginRight: 8, color: "#fa8c16" }} />Origen & Pérdidas</span>}
          subTitle="De dónde vienen tus prospectos y por qué se pierden"
          onBack={() => history.push("/panel/crmReportes")}
          style={{ border: "1px solid rgb(235,237,240)", backgroundColor: "white", marginBottom: 15 }}
          extra={
            <Space wrap>
              {hayDatos && (
                <Tooltip title="Descargar Excel">
                  <span>
                    <ButtonItem verde icon={<FileExcelOutlined />} onClick={this.descargarExcel} />
                  </span>
                </Tooltip>
              )}
              {hayDatos && (
                <Tooltip title="Descargar PDF">
                  <span>
                    <ButtonItem rojo icon={<FilePdfOutlined />} onClick={this.descargarPdf} loading={loadingOrigen} />
                  </span>
                </Tooltip>
              )}
              <ButtonItem azul htmlType="submit">Consultar</ButtonItem>
            </Space>
          }
        />

        {/* Cintillo de filtros */}
        <div style={{
          backgroundColor: "white", padding: 20, paddingTop: 5,
          borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)", marginBottom: 10,
        }}>
          <Tabs
            defaultActiveKey="1"
            style={{ margin: 0 }}
            tabBarExtraContent={{ left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1> }}
          >
            <TabPane key="1" tab="Periodo">
              <FormItem name="periodo" noStyle>
                <RangePickerItem />
              </FormItem>
            </TabPane>
            <TabPane key="2" tab="Embudo">
              <FormItem name="embudoId" noStyle>
                <SelectItem
                  placeholder="Todos los embudos"
                  allowClear
                  style={{ width: "90%" }}
                >
                  {embudos.map((e) => (
                    <Option key={e._id} value={e._id}>{e.nombreEmbudo}</Option>
                  ))}
                </SelectItem>
              </FormItem>
            </TabPane>
          </Tabs>
        </div>

        <Spin spinning={loading}>
          <Row gutter={[16, 16]}>
            <Col xs={24} lg={12}>
              <Card title="Distribución por Origen" style={CARD_STYLE}>
                {datosOrigen.length === 0 && !loadingOrigen ? (
                  <Empty description="Sin datos de origen registrados" />
                ) : (
                  <>
                    <div style={{ height: 300 }}>
                      <ResponsivePie
                        data={datosOrigen}
                        margin={{ top: 20, right: 80, bottom: 60, left: 80 }}
                        innerRadius={0.4} padAngle={1} cornerRadius={3}
                        colors={COLORES_ORIGEN}
                        borderWidth={1}
                        borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
                        legends={[{
                          anchor: "bottom", direction: "row", translateY: 52,
                          itemWidth: 90, itemHeight: 18, itemTextColor: "#444",
                          symbolSize: 10, symbolShape: "circle",
                        }]}
                        tooltip={({ datum }) => (
                          <div style={{ background: "white", padding: "6px 12px", border: "1px solid #f0f0f0", borderRadius: 6 }}>
                            <strong>{datum.label}</strong>: {datum.value} leads
                          </div>
                        )}
                      />
                    </div>
                    <Table dataSource={datosOrigen} columns={columnsOrigen}
                      rowKey="id" size="small" pagination={false} style={{ marginTop: 8 }} />
                  </>
                )}
              </Card>
            </Col>

            <Col xs={24} lg={12}>
              <Card title="Motivos de Pérdida" style={CARD_STYLE}>
                {datosMotivos.length === 0 && !loadingMotivos ? (
                  <Empty description="Sin leads perdidos con motivo registrado" />
                ) : (
                  <>
                    <div style={{ height: 240 }}>
                      <ResponsivePie
                        data={datosMotivos.slice(0, 8)}
                        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                        innerRadius={0.4} padAngle={1} cornerRadius={3}
                        colors={COLORES_PERDIDA}
                        tooltip={({ datum }) => (
                          <div style={{ background: "white", padding: "6px 12px", border: "1px solid #f0f0f0", borderRadius: 6 }}>
                            <strong>{datum.label}</strong>: {datum.value}
                          </div>
                        )}
                      />
                    </div>
                    <Table dataSource={datosMotivos} columns={columnsMotivos}
                      rowKey="id" size="small" pagination={false} style={{ marginTop: 8 }} />
                  </>
                )}
              </Card>
            </Col>
          </Row>
        </Spin>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId:    state.empresa.id,
});

export default withRouter(connect(mapStateToProps)(ReporteLeadsCRM));
